import { render, staticRenderFns } from "./ManagerStatements.vue?vue&type=template&id=0d5b076e&scoped=true"
import script from "./ManagerStatements.vue?vue&type=script&lang=js"
export * from "./ManagerStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b076e",
  null
  
)

export default component.exports